// extracted by mini-css-extract-plugin
module.exports = {"root":"PressQuote_root__3aUoU","quote":"PressQuote_quote__1lVcl","source":"PressQuote_source__1fWYa"};